import React from 'react';
import { cn } from '../../lib/cn';
import { ViewportOverlay } from '../Overlay/ViewportOverlay';
import { Icon } from '../Icon/Icon';

export interface ModalProps {
  title: React.ReactNode;
  children: React.ReactNode;
  onClose: () => void;
  footer?: React.ReactNode;
  open?: boolean;
  className?: string;
}

export function Modal({ title, children, onClose, footer, open = true, className }: ModalProps) {
  return (
    <ViewportOverlay open={open} onClose={onClose}>
      <div
        onClick={(event) => {
          event.stopPropagation();
        }}
        className={cn(
          'cal-modal w-[min(440px,calc(100vw-32px))] overflow-hidden rounded-[var(--r-xl)] border border-[var(--cream-2)] bg-[var(--cream-1)] shadow-[var(--sh-3)]',
          className,
        )}
      >
        <div className="flex items-center justify-between border-b border-[var(--cream-2)] px-6 py-5">
          <h3 className="m-0 font-[var(--font-display)] text-xl font-semibold tracking-[-0.02em] text-[var(--ink-0)]">
            {title}
          </h3>
          <button
            type="button"
            onClick={onClose}
            className="flex h-[30px] w-[30px] cursor-pointer items-center justify-center rounded-full bg-[var(--cream-0)] text-[var(--ink-2)]"
          >
            <Icon kind="x" size={15} stroke={2} />
          </button>
        </div>
        <div className="p-6 text-sm leading-normal text-[var(--ink-1)]">{children}</div>
        {footer ? (
          <div className="flex justify-end gap-2.5 border-t border-[var(--cream-2)] bg-[var(--cream-0)] px-6 py-4">
            {footer}
          </div>
        ) : null}
      </div>
    </ViewportOverlay>
  );
}
